"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.sourceType.group': 'Grupa',
    'whatsapp.sourceType.dm': 'Wiadomość',
    'whatsapp.sourceType.email': 'Email',
};
